<template>
    <div class="main-cn">
        <div class="main-bd mg20 pro-visible">
            <el-form ref="form" :inline="true" :model="searcheModel">
                <el-form-item>
                    <el-select size="small" v-model="searcheModel.time_type" placeholder="请选择" style="width: 150px;">
                        <el-option label="客户创建时间" value="1"></el-option>
                        <el-option label="录单时间" value="2"></el-option>
                    </el-select>
                    <el-date-picker
                        size="small"
                        v-model="searcheModel.created_at"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <DistrictLinkage ref="DistrictLinkage" :provinceId="searcheModel.province_id"  :cityId="searcheModel.city_id" :districtId="searcheModel.district_id"  @change="handleChange($event)" ></DistrictLinkage>
                <el-form-item label="客户级别" >
                    <el-select v-if="levels" size="small" v-model="searcheModel.level" placeholder="请选择" >
                        <el-option v-for="(item,key) in levels" :key="key" :label="item" :value="key" >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属部门">
                    <UserCascader
                        v-model="searcheModel.branch_id"
                        ref="branch"
                        :isBusiness="true"
                        @change="changeBranch"
                    ></UserCascader>
                </el-form-item>
                <el-form-item label="业务员">
                    <UserSelect
                        ref="user"
                        @change="salesmanHandleChange"
                    ></UserSelect>
                </el-form-item>
                <el-form-item label="订单类型">
                    <el-select v-model="searcheModel.order_type" size="mini">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="试用" value="1"></el-option>
                        <el-option label="正式(新单)" value="2"></el-option>
                        <el-option label="正式(续单)" value="3"></el-option>
                        <el-option label="正式" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="申请产品">
                    <Product ref="product" :product_id="searcheModel.product_id"
                    @change="productChange"></Product>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="submitSearch">搜索</el-button>
                    <el-button @click="resetForm()" size="small">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="main-bd mg20 pro-visible" v-loading="loading">
            
            <h5>客户数量概览</h5>
            <div class="flex-container">
                <!-- 左侧 -->
                <div class="left" style="text-align: center;">
                    <div>
                        总客户数    {{origin_data.total}}
                    </div>
                </div>

                <!-- 右侧 -->
                <div class="right">
                    <!-- 上方 -->
                    <div class="right-top">
                        <h5>&nbsp;&nbsp;客户类型</h5>
                        <div style="padding-left: 15px;">
                            <el-row :gutter="10">
                                <el-col  v-for="(origin, index) in origin_data.customer_types" :key="index" :label="origin.name" :span="3">
                                    <div class="grid-content">
                                        <div class="ellipsis">{{ origin.name }}</div>
                                        <div class="ellipsis">{{ origin.value }}</div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>

                    <!-- 下方 -->
                    <div class="right-bottom">
                        <h5>&nbsp;&nbsp;成交客户</h5>
                        <div style="padding-left: 15px;">
                            <el-row :gutter="10">
                                <el-col :span="4">
                                    <div class="grid-content">
                                        <div class="ellipsis">成交客户数</div>
                                        <div class="ellipsis">
                                            {{ origin_data.formal_customer_num }}
                                        </div>
                                    </div>
                                </el-col>
                                <el-col v-if="searcheModel.time_type !== '2'" :span="4">
                                    <div class="grid-content">
                                        <div class="ellipsis">复购率</div>
                                        <div class="ellipsis repurchase-rate">
                                            {{ repurchaseRate }}
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="grid-content">
                                        <div class="ellipsis">新增正式客户</div>
                                        <div class="ellipsis">
                                            {{ origin_data.first_formal_customer_num }}
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="grid-content">
                                        <div class="ellipsis">二次合作客户数</div>
                                        <div class="ellipsis">
                                            {{ origin_data.second_formal_customer_num }}
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="grid-content">
                                        <div class="ellipsis">断续客户数</div>
                                        <div class="ellipsis">
                                            {{ origin_data.stop_renew_customer_num }}
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-bd mg20 pro-visible" v-loading="loading">
            <el-row class="searchSection">
                <el-col :span="3">
                    <h5>客户来源趋势</h5>
                </el-col>
                <el-col :span="2" :offset="19">
                    <ExportFile url="/api/export/customer-origin" :params="searcheModel" filename="客户来源趋势数据表">导出</ExportFile>
                </el-col>
            </el-row>
            <CustomerOriginChart :params="searcheModel" :key="origin_chart_key"></CustomerOriginChart>
        </div>
        <div class="main-bd mg20 pro-visible" v-loading="loading">
            <el-row class="searchSection">
                <el-col :span="2">
                    <h5>体量分析</h5>
                </el-col>
                <el-col :span="2" :offset="19">
                    <ExportFile url="/api/export/customer-size" :params="searcheModel" filename="体量分析数据表">导出</ExportFile>
                </el-col>
            </el-row>
            <CustomerSize :params="searcheModel" :key="size_key"></CustomerSize>
        </div>
        <div class="main-bd mg20 pro-visible" v-loading="loading">
            <el-row class="searchSection">
                <el-col :span="3">
                    <h5>学段统计</h5>
                </el-col>
                <el-col :span="2" :offset="19">
                    <ExportFile url="/api/export/customer-stage" :params="searcheModel" filename="学段统计数据表">导出</ExportFile>
                </el-col>
            </el-row>
            <CustomerStageChart :params="searcheModel" :key="stage_chart_key"></CustomerStageChart>
        </div>
        <div class="main-bd mg20 pro-visible" v-loading="loading">
            <el-row class="searchSection">
                <el-col :span="3">
                    <h5>成交客户地区分布</h5>
                </el-col>
                <el-col :span="2" :offset="19">
                    <ExportFile url="/api/export/finish-area" :params="searcheModel" filename="成交客户地区分布">导出</ExportFile>
                </el-col>
            </el-row>
            <AreaTable :params="searcheModel" :key="area_key"></AreaTable>
        </div>

        <div class="main-bd mg20 pro-visible" v-loading="loading">
            <el-row class="searchSection">
                <el-col :span="3">
                    <h5>成交客户产品分布</h5>
                </el-col>
                <el-col :span="2" :offset="19">
                    <ExportFile url="/api/export/finish-product" :params="searcheModel" filename="成交客户产品分布">导出</ExportFile>
                </el-col>
            </el-row>
            <ProductTable :params="searcheModel" :key="product_key"></ProductTable>
        </div>
    </div>
</template>
<style scoped>
.flex-container {
  display: flex;
  align-items: stretch; /* 垂直方向上对齐 */
}

.left {
  flex: 1; /* 左侧占据所有可用空间 */
  display: flex;
  justify-content: center; /* 水平方向上居中对齐 */
  align-items: center; /* 垂直方向上居中对齐 */
  border: 2px solid #ccc; /* 添加边框线 */
}

.right {
  flex: 3; /* 右侧占据左侧的两倍空间 */
  display: flex;
  flex-direction: column; /* 上下布局 */
}

.right-top, .right-bottom {
  flex: 1; /* 上下两个部分平分高度 */
  border: 2px solid #ccc; /* 添加边框线 */
}
.main-bd .el-row {
    padding: 10px 0;
}
.grid-content {
   text-align: center;
   margin-bottom: 10px;
}
.ellipsis {
    margin-bottom: 10px;
}
.repurchase-rate {
    position: relative;
    display: inline-block;
}

.rate-badge {
    display: inline-block;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 12px;
    margin-left: 5px;
    font-weight: bold;
}
</style>
<script>

import CustomerCount from "~/services/CustomerCount";
import CustomerService from "~/services/customer";
import ExportFile from "~/widgets/ExportFile.vue";
import UserCascader from "~/widgets/UserCascader.vue";
import UserSelect from "~/widgets/UserSelect.vue";
import ChannelCascader from "~/widgets/ChannelCascader.vue";
import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
import CustomerOriginChart from "~/views/count/echarts/customerOriginChart.vue";
import CustomerStageChart from "~/views/count/echarts/customerStageChart.vue";
import CustomerSize from "~/views/count/table/customerSize.vue";
import Product from "~/widgets/Product.vue";
import AreaTable from "~/views/count/customer/area.vue";
import ProductTable from "~/views/count/customer/product.vue";
import Config from "~/config/params";

export default{
    name: 'deal',

    components: {
        ExportFile,
        UserCascader,
        UserSelect,
        ChannelCascader,
        DistrictLinkage,
        CustomerOriginChart,
        CustomerStageChart,
        Config,
        CustomerSize,
        Product,
        AreaTable,
        ProductTable
    },

    data() {
        return {
            loading: false,
            searcheModel: {},
            origin_data: {},
            origin_chart_key: 0,
            stage_chart_key: 0,
            size_key: 0,
            area_key: 0,
            product_key: 0,
            levels: {},
            size_list: [],
            total_list: [],
            formal_customer_list: [],
            formal_order: [],
            performance_list: [],
            renew: [],
            province_id: 0,
            city_id: 0,
            district_id: 0,
        };
    },
  computed: {
        // 计算复购率
        repurchaseRate() {
            const formalNum = this.origin_data.formal_customer_num || 0;
            const secondNum = this.origin_data.second_formal_customer_num || 0;

            if (formalNum === 0) {
               return '0.00%'
            }

            const rate = (secondNum / formalNum * 100).toFixed(2);
            return rate + '%';
        }
    },
    created(){
        this.levels = CustomerService.getLevels(true);
        this.resetForm();
    },
    
    methods: {

        //重置按钮
        resetForm() {
            this.searcheModel = {
                branch_id: "",
                user_id: "",
                created_at: Config.getDataTimes('to_day'),
                province_id:0,
                city_id:0,
                district_id:0,
                time_type: '1',
                level: '',
                order_type: '',
                // not_have_amount: '',
                product_id: '',
            };
            if(this.$refs['branch']){
                this.$refs['branch'].reset();
            }
            if(this.$refs['user']){
                this.$refs['user'].reset();
            }
            this.list = [];
            this.submitSearch();
        },

        // 筛选查询
        submitSearch() {
            if (!this.searcheModel.created_at || this.searcheModel.created_at.length == 0){
                this.$message({
                    message: '时间范围筛选不能为空！',
                    type: "error"
                });
                return false;
            }
            this.getOriginData(this.searcheModel);
            this.origin_chart_key ++;
            this.stage_chart_key ++;
            this.size_key ++;
            this.area_key ++;
            this.product_key ++;
        },

        //客户数量概览
        getOriginData(params) {
            // loading 动画
            this.loading = true;
            CustomerCount.getCount(params, 'collect-data')
            .then((res) => {
                if (res.code == 0) {
                    this.origin_data = res.data;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        
        //切换部门子组件
        changeBranch(value) {
            if (value.length > 0) {
                // 取得最后一级部门作为所属部门
                this.searcheModel.branch_id = value[value.length - 1];
            } else {
                this.searcheModel.branch_id = "";
            }
        },

        //切换业务员子组件
        salesmanHandleChange(object) {
            this.searcheModel.user_id = object.label;
        },

        //地区联动 Cascader 级联选择器,切换事件,表单model赋值
        handleChange(value) {
            this.searcheModel.province_id = parseInt(value[0]);
            this.searcheModel.city_id = parseInt(value[1]);
            this.searcheModel.district_id = parseInt(value[2]);
        },

        productChange(value) {
            this.searcheModel.product_id = value;
        },


        handleView(type) {
            var params = _.clone(this.searcheModel);
            if(type > 0){
                params['formal_status'] = type;
            }else{
                params['stop_renew'] = 1;
            }
            delete params['order_type'];
            params['product_type'] = this.searcheModel.order_type;
            let routeData = this.$router.resolve({
                path: "/customers/index",
                query: params,
            });
            window.open(routeData.href, '_blank');
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/views/count/customer/deal.vue